/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { instanceWithIntegrationsSchema } from './instanceWithIntegrationsSchema';

export const integrationsGroupedBySourceSystemSchema = z.object({
  get instances() {
    return z.array(instanceWithIntegrationsSchema);
  },
  sourceSystem: z.enum(['JIRA', 'ADO']),
});
